<template>
    <div class="text-center">
        <v-dialog v-model="dialog" width="1000">
            <v-card>
                <v-card-title class="text-h5 bg-grey-lighten-2" primary-title>
                    {{ this.wellData[0] ? this.wellData[0].qr_code : "" }}
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row v-for="(row, index) in wellMap" :key="index">
                            <v-col v-for="well in row" :key="well.id">
                                <v-tooltip location="right">
                                    <template v-slot:activator="{ props }">
                                        <v-btn
                                            v-bind="props"
                                            class="ml-4"
                                            size="large"
                                            @click="linkWell({ well: well })"
                                            :class="
                                                well.complete != null ? well.complete : 'md-alive'
                                            "
                                        >
                                            {{ well.well_pos }}<br />{{
                                                `${well.condition_id}-${well.rep_num}`
                                            }}
                                        </v-btn>
                                    </template>
                                    <span>CONDITION: {{ well.condition_id }}</span
                                    ><br />
                                    <ul
                                        v-for="(item, index) in batchMap(well.condition_id)"
                                        :key="index"
                                    >
                                        <li>{{ item[0] }}<br />{{ `${item[1]} ${item[2]}` }}</li>
                                    </ul>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn color="primary" @click="cancelIt"> Close - do not set defaults </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="protocolId !== 'bfi_r2Ikak9w' && displayInverseBtn"
                        color="primary"
                        @click="invertDefaults"
                    >
                        Invert Defaults
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <well-form></well-form>
    </div>
</template>

<script>
import { defineComponent } from "vue";

import WellForm from "./WellForm";
import { EventBus } from "../../lib/event-bus.js";
import axios from "../../lib/apiAxios";
import moment from "moment";
import _ from "lodash";

export default defineComponent({
    name: "container-form",

    components: {
        WellForm,
    },

    unmounted: function () {
        EventBus.$off();
    },

    beforeMount: function () {
        this.protocolId = this.$route.params.protocolId;
    },

    mounted: function () {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        this.protocolId = this.$route.params.protocolId;
        EventBus.$on("dialog", function (data) {
            console.log("eventbus dialog");
            this.outputs = data.outputs;
            if (data.displayContainer) {
                self.dialog = self.$route.params.protocolId;
                self.refreshData();
            }
        });

        EventBus.$on("message", (data) => {
            if (data.refresh) {
                let updatedWell = data.refresh;
                self.wellData.forEach(function (well) {
                    if (well.id === updatedWell.id) {
                        for (let property in updatedWell) {
                            let found = ["id", "qr_code", "well", "date_measured"].find(
                                function (element) {
                                    return element === property;
                                }
                            );
                            if (!found) {
                                console.log("atributes found #########");
                                console.log(property);
                                console.log(well.data);
                                well.data[property] = updatedWell[property];
                            }
                        }
                    }
                });
                self.colorwell();
            }
        });
        axios.get(`/experiment/${this.$route.params.code}/batches`).then((batchResponse) => {
            const batchArr = batchResponse.data;
            batchArr.forEach((batch) => {
                if (batch.concentration) batch.concentration = batch.concentration.split(",");
                if (batch.concentration_units)
                    batch.concentration_units = batch.concentration_units.split(",");
            });
            this.batchArr = batchArr;
        });
    },

    created: function () {},

    methods: {
        refreshData: function () {
            this.qrCode = this.$route.params.qrCode;
            axios
                .get(`/container/${this.qrCode}`)
                .then((response) => {
                    // console.log('@@@@@@@@@@@@@@@@@ container data');
                    // console.log(response.data);
                    this.container = response.data;
                })
                .catch((error) => {
                    console.log("there has been an error");
                    console.log(error);
                });

            axios
                .get(`/container/${this.qrCode}/wells/${this.$route.params.date}`)
                .then((response) => {
                    this.wellData = response.data;

                    for (let i = 0; i < this.wellData.length; i++) {
                        if (!this.wellData[i].data) {
                            this.wellData[i].data = {};
                        }
                    }

                    if (this.wellData && this.wellData.length) {
                        axios
                            .get(`/experiment/qrcode/${this.qrCode}`)
                            .then((experimentResponse) => {
                                let expStartDate = moment(experimentResponse.data.start_date);
                                axios
                                    .get(`/benchling/type/${this.$route.params.protocolId}`)
                                    .then((assayResponse) => {
                                        this.formDataFields = assayResponse.data[0];
                                        this.formDataFields.outputRules = [];

                                        // get Experiment day num
                                        let now = moment(new Date()); // todays date
                                        let dayNum = now.diff(expStartDate, "days");

                                        this.formDataFields.outputs.forEach((rule) => {
                                            if (
                                                !rule.day ||
                                                rule.day === dayNum ||
                                                _.includes(rule.day, 1)
                                            ) {
                                                this.formDataFields.outputRules.push(rule);
                                            }
                                            if (_.has(rule, "inverse_default")) {
                                                this.displayInverseBtn = true;
                                            }
                                        });

                                        this.setWellDefaults();

                                        console.log("container ---");
                                        console.log(this.container);
                                        if (this.$route.params.wellId) {
                                            this.openModal(
                                                this.wellData,
                                                this.$route.params.wellId
                                            );
                                        }
                                    });
                                this.colorwell();
                            });
                    } else {
                        this.error = "Container has not been defined!";
                    }
                });
        },
        linkWell: function (data) {
            EventBus.$emit("dialog-sub", {
                wellData: data.well,
                outputs: this.formDataFields.outputRules,
                width: 600,
                height: 600,
            });
        },

        setWellDefaults: function () {
            this.wellData.forEach((well, cnt) => {
                this.formDataFields.outputs.forEach((field) => {
                    if (_.has(field, "default")) {
                        if (!well.data.hasOwnProperty(field.name)) {
                            this.wellData[cnt].data[field.name] = field.default;
                        }
                    }
                });
            });
        },

        colorwell: function () {
            // Get the field that determines well style from outputs
            const { name, options } = this.$parent.outputs.filter(
                (output) => output.options && output.options.filter((option) => option.style)
            )[0];
            if (this.wellData[0].data) {
                // Match well data with field options to determine well style
                this.wellData.forEach((ele) => {
                    if (name && name in ele.data) {
                        const styleAttr = options.filter(
                            (option) => option.value === ele.data[name]
                        );
                        const style =
                            styleAttr && styleAttr[0] && styleAttr[0].style
                                ? styleAttr[0].style
                                : null;
                        ele.complete = style;
                    }
                });
            }
            this.$forceUpdate();
        },

        close: function () {},

        cancelIt: function () {
            this.dialog = false;
            // this.$router.push({path: `/experiment/${this.$route.params.code}/${this.$route.params.protocolId}`});
        },

        invertDefaults: function () {
            this.wellData.forEach((well, cnt) => {
                this.formDataFields.outputs.forEach((field) => {
                    if (_.has(field, "inverse_default")) {
                        this.wellData[cnt].data[field.name] = field.inverse_default;
                    }
                });
            });
            this.colorwell();
        },

        clicked: function () {
            console.log("clicked");
        },

        refresh: function () {
            this.$forceUpdate();
        },

        batchMap: function (cond) {
            const condBatchArr = [];
            const condBatch = this.batchArr.filter((batch) => batch.condition_number === cond)[0];
            if (condBatch && condBatch.batch) {
                for (let i = 0; i < condBatch.batch.length; i++) {
                    condBatchArr.push([
                        condBatch.batch && condBatch.batch[i] ? condBatch.batch[i] : "",
                        condBatch.concentration && condBatch.concentration[i]
                            ? condBatch.concentration[i]
                            : "",
                        condBatch.concentration_units && condBatch.concentration_units[i]
                            ? condBatch.concentration_units[i]
                            : "",
                    ]);
                }
            }
            if (condBatchArr.length === 0) {
                condBatchArr.push(["No Actives", "", ""]);
            }
            return condBatchArr;
        },
    },

    computed: {
        wellMap: function () {
            return _.groupBy(this.wellData, (item) => {
                return item.well_pos.charAt(0);
            });
        },
    },

    data: () => ({
        dialog: null,
        displayInverseBtn: false,
        outputs: null,
        protocolId: null,
        QRcode: null,
        formDataFields: {
            outputRules: [],
        },
        wellData: [],
        batchArr: [],
    }),
});
</script>

<style>
.md-alive {
    background-color: #66bb6a !important;
    color: #ffffff !important;
}
.md-dead {
    background-color: #d1bc1f !important;
    color: #ffffff !important;
}
.md-missing {
    background-color: #969696 !important;
    color: #ffffff !important;
}
.md-ignore {
    background-color: #424242 !important;
    color: #ffffff !important;
}
</style>
